import React, {useState} from 'react'
import { Document, Page } from 'react-pdf/dist/umd/entry.webpack'
import './pdf.css'

export default function PdfViewer({url, handlePdfViewer}) {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    }

    const updatePageNumber = (page) => {
        setPageNumber(page)
    }

    return (
        <div className='pdf'>
            <button className="pdf__close" onClick={() => handlePdfViewer(false)}>X</button>
            <div className="pdf__container">
                <Document
                    file={url}
                    onLoadSuccess={onDocumentLoadSuccess}
                >
                    <Page pageNumber={pageNumber} />
                </Document>
                <div class="page-controls">
                    <button type="button" disabled={pageNumber === 1} onClick={() => updatePageNumber(pageNumber - 1)}>‹</button>
                    <span>{pageNumber} of {numPages}</span>
                    <button type="button" disabled={pageNumber === numPages} onClick={() => updatePageNumber(pageNumber + 1)}>›</button>
                </div>
            </div>
        </div>
    )
}